import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';

const DeleteModal = ({ open, onClose, onConfirm, simulator }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('simulatorSuperAdmin.deleteModal.title')}</DialogTitle>

      <DialogContent>
        <Typography>
          {t('simulatorSuperAdmin.deleteModal.confirmText', { name: simulator?.name })}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button onClick={onConfirm} color="error">{t('common.delete')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
